import React from "react";
import { useSelector } from "react-redux";

export default function Permission({ roles, groups, component: Component }) {
  const user = useSelector((state) => state.user.data);

  const rolesIdentify = roles?.some((role) => role === user.roles);
  const groupIdentify = groups?.some((group) => user.userGroup.includes(group));

  if (roles && groups) return rolesIdentify && groupIdentify && <Component />;
  if (groups) return groupIdentify && <Component />;
  if (roles) return rolesIdentify && <Component />;
  return <Component />;
}
